var sliderInterval,
	autoSlide,
	intervalTime = 7000,
	sliderSection = document.querySelector('section.slider'),
	isMultipleSliders = document.querySelectorAll('section.slider').length > 1;

if(!isMultipleSliders && document.querySelectorAll('section.slider .slide').length > 1) {
	var sliderWaypoint = new Waypoint({
		element: sliderSection,
		handler: function(direction) {
			sliderInterval = setInterval(autoSlide, intervalTime);

			this.destroy();
		},
		offset: '100%'
	});

	autoSlide = function() {
		if(document.visibilityState === 'visible')
			setCurrentSlide('next');
	};
}

[].slice.call(document.querySelectorAll('section.slider')).forEach(function(slider) {
	[].slice.call(slider.querySelectorAll('.bullets .bullet, .next-prev button')).forEach(function(button, index) {
		button.addEventListener('click', function() {
			if(!this.classList.contains('current')) {
				sliderSection = slider;
				setSliderInterval(this.classList.contains('bullet') ? index : this.className);
			}
		});
	});
});

document.addEventListener('keydown', function(e) {
	var activeElement = document.activeElement;

	if(activeElement.closest('.controller')) {
		var key = e.key,
			direction = key == 'ArrowRight' ? 'next' : (key == 'ArrowLeft' ? 'prev' : '');

		if(direction) {
			setSliderInterval(direction);
			activeElement.closest('.controller').querySelector('button.'+direction).focus();
		}
	}
});

function setSliderInterval(index) {
	setCurrentSlide(index);

	if(!isMultipleSliders) {
		clearInterval(sliderInterval);
		sliderInterval = setInterval(autoSlide, intervalTime);
	}
}

function setCurrentSlide(index) {
	var currentSlide,
		slides = sliderSection.querySelectorAll('.slide'),
		slidesLength = slides.length-1,
		bullets = sliderSection.querySelectorAll('.bullets .bullet');

	[].slice.call(slides).forEach(function(slide, index) {
		if(window.getComputedStyle(slide).visibility == 'visible') {
			currentSlide = index;
			return;
		}
	});

	Velocity(slides[currentSlide], {opacity: [0,1]}, {duration: 600, visibility: 'hidden'});

	bullets[currentSlide].classList.remove('current');

	if(index == 'next') {
		currentSlide = currentSlide == slidesLength ? 0 : ++currentSlide;
	} else if(index == 'prev') {
		currentSlide = currentSlide == 0 ? slidesLength : --currentSlide;
	} else {
		currentSlide = index;
	}

	Velocity(slides[currentSlide], {opacity: [1,0]}, {duration: 600, visibility: 'visible'});

	bullets[currentSlide].classList.add('current');
}